import {Node} from 'prosemirror-model'
import {Plugin, Transaction} from 'prosemirror-state'
import {Decoration, DecorationSet} from 'prosemirror-view'

import {schema} from '../schema/hybrid-markdown-schema'
import styles from './hybrid-block.module.css'

function decorateHeadingDelimiters(doc: Node): DecorationSet {
  const decorations: Decoration[] = []
  doc.descendants((node, pos) => {
    // TODO: better typesafety for node attributes
    if (node.type === schema.nodes.heading && 'level' in node.attrs && typeof node.attrs.level === 'number') {
      decorations.push(
        // +1 because the end is exclusive, and +1 more for the whitespace
        Decoration.inline(pos, pos + node.attrs.level + 2, {
          class: styles.delimiter,
        }),
      )
    }
  })
  return DecorationSet.create(doc, decorations)
}

// TODO: Only supports #-style headings, but there are other kinds as well
const headingDelimeterRegex = /^(#{1,6}) /

// Headings are a specific node type, so we need to ensure that the node type is correct by changing it if the delimeter changes.
// TODO: I actually wonder if headings can just be paragraph nodes with a Decoration.node to swap the tag - then we can
// use the same logic as for inline formatting, and this gets a lot simpler.
function updateHeadingLevels(transaction: Transaction) {
  transaction.doc.descendants((node, pos) => {
    if (node.type === schema.nodes.heading || node.type === schema.nodes.paragraph) {
      const match = node.textContent.match(headingDelimeterRegex)
      if (match?.[1]) {
        const level = match[1].length
        if (node.type === schema.nodes.paragraph || node.attrs.level !== level) {
          transaction.setNodeMarkup(pos, schema.nodes.heading, {level})
        }
      } else if (node.type === schema.nodes.heading) {
        // If it was a heading but no longer matches the regex, convert to paragraph
        transaction.setNodeMarkup(pos, schema.nodes.paragraph)
      }
    }
  })
}

export const markdownHeadingsPlugin = () =>
  new Plugin({
    state: {
      init(_, {doc}) {
        return decorateHeadingDelimiters(doc)
      },
      apply(tr, oldDecorations) {
        if (tr.docChanged) {
          return decorateHeadingDelimiters(tr.doc)
        }
        return oldDecorations
      },
    },
    props: {
      decorations(state) {
        return this.getState(state)
      },
    },
    appendTransaction(transactions, oldState, newState) {
      if (transactions.some(tr => tr.docChanged && !tr.getMeta('decorateHeadings'))) {
        const newTr = newState.tr
        newTr.setMeta('decorateHeadings', true)
        updateHeadingLevels(newTr)
        return newTr
      }
      return null
    },
  })
